import { Button } from 'cwp-components/forms'

type props = {
  setRating?: any
  rating?: number
  label?: string
  feedback?: boolean
  setFeedbackText?: (value: String) => void
  onSubmit?: () => void
  isProcessing?: boolean
}

const Ratings = ({
  rating,
  setRating,
  label,
  feedback,
  onSubmit,
  setFeedbackText,
  isProcessing = false,
}: props) => {
  return (
    <div>
      <div className='w-[213px] mx-auto'>
        <div className='flex justify-center gap-[7px] mb-2'>
          {[1, 2, 3, 4, 5].map((star) => {
            return (
              <div key={star}>
                <svg
                  onClick={() => {
                    setRating(star)
                  }}
                  className={`cursor-pointer xl:w-[32px] xl:h-[32px] h-[24px] w-[24px]`}
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 32 32'
                  fill='none'
                >
                  <path
                    d='M11.3071 11.3418L11.5663 11.3043L11.6832 11.0699L14.8077 4.79926C15.1856 4.04161 16.2814 4.04524 16.6596 4.7996C16.6597 4.79973 16.6598 4.79986 16.6598 4.79999L19.784 11.0699L19.9008 11.3043L20.1601 11.3418L27.1511 12.3506L27.1514 12.3506C28.0002 12.4725 28.3269 13.4991 27.7225 14.0817L27.7223 14.0818L22.6645 18.9602L22.4736 19.1443L22.519 19.4056L23.7152 26.2965C23.8569 27.1162 22.9781 27.7592 22.2185 27.3639L22.2184 27.3639L15.9644 24.11L15.7336 23.99L15.5028 24.11L9.24878 27.3639L9.24721 27.3647C8.49117 27.7614 7.60992 27.1193 7.75195 26.2967C7.75196 26.2966 7.75197 26.2965 7.75198 26.2965L8.94818 19.4056L8.99354 19.1443L8.80266 18.9602L3.74488 14.0818L3.74473 14.0817C3.14026 13.4991 3.46703 12.4725 4.31577 12.3506L4.31613 12.3506L11.3071 11.3418Z'
                    stroke='#093269'
                    fill={rating >= star ? '#093269' : ''}
                  />
                </svg>
              </div>
            )
          })}
        </div>
        <div className='flex justify-between text-[10px] xl:text-sm text-[#122D5C] '>
          <p>Not {label}</p>
          <p>Very {label}</p>
        </div>
      </div>
      {feedback && rating > 0 && (
        <div className='mx-auto text-center mt-[30px]'>
          <h1 className='md:!text-[18px] !text-sm text-[#122D5C] !font-normal'>
            How was your overall experience?
          </h1>
          <textarea
            placeholder='Very helpful'
            className='h-[142px] md:w-[368px] w-[240px] mt-[16px] text-[16px] text-[#37A2BA] font-normal appearance-none p-[12px]  rounded-[8px] border-[1px] border-[#B3EBF9] shadow-[0px_1.2px_4px_0px_rgba(0,0,0,0.15)]'
            name=''
            id=''
            onChange={(e) => {
              if (setFeedbackText) setFeedbackText(e.target.value)
            }}
          ></textarea>
          <div className='flex justify-end mt-[20px]'>
            <Button
              className='font-normal text-[12px] text-[#1C7D93]'
              onClick={() => {
                if (onSubmit) {
                  onSubmit()
                }
              }}
              disabled={isProcessing}
            >
              Submit
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Ratings
